import { useEffect, useState } from 'react';

type ConsentType = {
    necessary: boolean;
    preferences: boolean;
    statistics: boolean;
    marketing: boolean;
};

export type CookiebotStateType = {
    consent: ConsentType;
    loaded: boolean;
};

declare global {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface Window {
        Cookiebot?: {
            consent?: ConsentType;
        };
    }
}

const getCookiebotState = (): CookiebotStateType => {
    if (typeof window !== 'undefined' && window.Cookiebot !== undefined && window.Cookiebot.consent !== undefined) {
        return {
            consent: window.Cookiebot.consent,
            loaded: true,
        };
    }
    return {
        consent: {
            necessary: false,
            preferences: false,
            statistics: false,
            marketing: false,
        },
        loaded: false,
    };
};

export const useCookiebot = (): CookiebotStateType => {
    const [state, setState] = useState<CookiebotStateType>({
        consent: {
            necessary: false,
            preferences: false,
            statistics: false,
            marketing: false,
        },
        loaded: false,
    });

    useEffect(() => {
        const updateState = (): void => {
            setState(getCookiebotState());
        };

        window.addEventListener('CookiebotOnLoad', updateState);
        window.addEventListener('CookiebotOnAccept', updateState);

        updateState();

        return () => {
            window.removeEventListener('CookiebotOnLoad', updateState);
            window.removeEventListener('CookiebotOnAccept', updateState);
        };
    }, []);

    return state;
};
